import dayjs from 'dayjs'

export class ReportsAdapter {
	static formatDate(date: Date): string {
		const outputFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

		return dayjs(date).format(outputFormat)
	}
}
